import _map from "lodash/map";
import _isEmpty from "lodash/isEmpty";
import _includes from "lodash/includes";
import _filter from "lodash/filter";
const ERROR_TYPES = ['backend-error', 'error', 'r-error'];
export const getDebugMessage = outputs => {
  const errors = _filter(outputs, _ref => {
    let {
      type
    } = _ref;
    return _includes(ERROR_TYPES, type);
  });
  if (!_isEmpty(errors)) {
    return _map(errors, 'payload').join('\n');
  }
  return JSON.stringify(outputs, null, 2);
};